import axios from 'axios';

/**
 * Checks if an endpoint is available and responding properly using OPTIONS method.
 * 
 * @param endpointUrl - The full URL of the endpoint to check
 * @param timeout - Optional timeout in milliseconds (default: 5000ms)
 * @returns Promise<boolean> - true if endpoint is healthy (2xx response), false otherwise
 */
export async function checkEndpointHealth(
  endpointUrl: string,
  timeout: number = 5000
): Promise<boolean> {
  try {
    const response = await axios.options(endpointUrl, {
      timeout,
      validateStatus: (status) => status >= 200 && status < 300
    });
    
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    // Return false for any error (network, timeout, 4xx, 5xx, etc.)
    return false;
  }
}

